import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-component" }
const _hoisted_2 = {
  key: 0,
  class: "topbar-component"
}
const _hoisted_3 = {
  key: 1,
  class: "side-bar-content-container"
}
const _hoisted_4 = { class: "sidebar-component" }
const _hoisted_5 = { class: "router-component" }
const _hoisted_6 = { key: 2 }

import { ref, watch, computed, provide, onMounted, onBeforeUnmount, onUnmounted, nextTick, inject } from "vue";
import TopBar from "@/components/TopBar.vue";
import SideBar from "@/components/SideBar.vue";
// Services
import { authService } from "@/auth/authSingleton";
import { globalReloadKey, loggerKey } from "./types/ServiceKeys";
import { nonSidebarViews, nonTopbarViews } from "@/router/RouteDetails";
import router from "./router";
import { AuthState } from "./auth/authStates";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const log = inject(loggerKey);
console.log(`App.vue\nSetting log level to: ${process.env.VUE_APP_LOG_LEVEL}`);
if (process.env.VUE_APP_LOG_LEVEL?.toLowerCase() === "trace".toLowerCase()) {
    log?.setLevel("trace");
    console.log(`Log level set to: trace (${log?.getLevel()})`);
}
else if (process.env.VUE_APP_LOG_LEVEL?.toLowerCase() === "debug".toLowerCase()) {
    log?.setLevel("debug");
    console.log(`Log level set to: debug (${log?.getLevel()})`);
}
else if (process.env.VUE_APP_LOG_LEVEL?.toLowerCase() === "info".toLowerCase()) {
    log?.setLevel("info");
    console.log(`Log level set to: info (${log?.getLevel()})`);
}
else if (process.env.VUE_APP_LOG_LEVEL?.toLowerCase() === "warn".toLowerCase()) {
    log?.setLevel("warn");
    console.log(`Log level set to: warn (${log?.getLevel()})`);
}
else if (process.env.VUE_APP_LOG_LEVEL?.toLowerCase() === "error".toLowerCase()) {
    log?.setLevel("error");
    console.log(`Log level set to: error (${log?.getLevel()})`);
}
else {
    log?.setLevel("warn");
    console.log(`Log level set to: warn (${log?.getLevel()})`);
}
provide(globalReloadKey, refreshRouterView);

const screenWidth = ref(window.innerWidth);
const showComponent = computed(() => screenWidth.value >= 800);
const key = ref(0);

provide("showComponent", showComponent);

onMounted(async () => {
    window.addEventListener("resize", updateFontSize)
    window.addEventListener('resize', handleResize);
    await ChangeSidebar();
    await ChangeTopbar();
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
});

onUnmounted(() => window.removeEventListener("resize", updateFontSize));
function updateFontSize() {
    var root = document.getElementsByTagName('html')[0];
    root.style.fontSize = `${getZoom()}vw`;
}

function handleResize() {
    screenWidth.value = window.innerWidth;
}

function getZoom(): number {
    var result = window.devicePixelRatio;
    log?.trace(`zoom level: ${result * 100}%`);

    return result;
}

const showSidebar = ref(false);
const showTopbar = ref(false);

watch(
    () => router.currentRoute.value.path,
    async () => {
        // log?.debug("path", route.path);
        await ChangeSidebar();
        await ChangeTopbar();
    }
);
async function isShowingSideBar() {
    return await authService.isLoggedIn() != AuthState.NOT_LOGGED_IN && !nonSidebarViews.some((substr) => router.currentRoute.value.path.startsWith(substr));
}
async function ChangeSidebar() {
    showSidebar.value = await isShowingSideBar();
}
async function isShowingTopBar() {
    return await authService.isLoggedIn() != AuthState.NOT_LOGGED_IN && !nonTopbarViews.some((substr) => router.currentRoute.value.path.startsWith(substr));
}
async function ChangeTopbar() {
    showTopbar.value = await isShowingTopBar();
}
function refreshRouterView() {
    log?.info('refreshing router view');
    key.value = key.value + 1;
    if (key.value > 1000) key.value = 0;
    nextTick(()=>{
        log?.info('pushing original router path', router.currentRoute.value.path);
        router.push({path:router.currentRoute.value.path, query:router.currentRoute.value.query});
    });
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showTopbar.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(TopBar)
        ]))
      : _createCommentVNode("", true),
    (showSidebar.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SideBar, { class: "side-bar" })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createBlock(_component_router_view, {
              key: key.value,
              class: "router-view"
            }))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(), _createBlock(_component_router_view, { key: key.value }))
        ]))
  ]))
}
}

})